import type {EditClientContactFormPayload} from "./edit-client-contact.schema";

import {editClientContact} from "@project/sdk/sales";
import {EditClientContactBody} from "@project/sdk/sales/zod";
import {mutationOptions} from "@tanstack/react-query";

import {clientKeys, clientMutationKeys} from "../../../../../client-keys";

import {editClientContactMapper} from "./edit-client-contact.mapper";

export function editClientContactMutationOptions(clientId: string, contactId: number) {
  return mutationOptions({
    mutationFn: (payload: EditClientContactFormPayload) =>
      editClientContact(
        clientId,
        contactId,
        EditClientContactBody.parse(editClientContactMapper.toSdk(payload)),
      ),
    mutationKey: clientMutationKeys.editClientContact,
    onSuccess: async (_result, _payload, _context, {client}) => {
      await Promise.all([
        client.invalidateQueries({queryKey: clientKeys.detail(clientId)}),
        client.invalidateQueries({queryKey: clientKeys.lists()}),
      ]);
    },
  });
}
